module.exports = __webpack_public_path__ + "static/img/medicala.721d0c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medicala.png
// module id = 41yr
// module chunks = 1